import { render, staticRenderFns } from "./CreateSmtpSetting.vue?vue&type=template&id=60c673a5"
import script from "./CreateSmtpSetting.vue?vue&type=script&lang=js"
export * from "./CreateSmtpSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports